module.exports = __webpack_public_path__ + "img/instagram.658d4c22.svg";